/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Col, Row } from 'antd';
import { isEmpty } from 'underscore';
import LiveVideosSelection from '../partials/LiveVideosSelection';
import LiveVideoScreen from '../partials/LiveVideoScreen';
import * as videoActions from '../../../core/video/videoActions';
import history from '../../../core/utils/history';

class LiveVideosTab extends Component {
    componentDidMount() {
        const { actions } = this.props;

        // if comes from main map, back to selection screen so that it can fetch data
        const urlParams = new URLSearchParams(window.location.search);
        const imei = urlParams.get('imei');
        if (!isEmpty(imei)) {
            actions.toggleVideoSelectionScreen(true);
        }
    }

    componentWillUnmount() {
        const { actions } = this.props;
        this.clearLiveVideos();
    }

    toggleVideoScreen = () => {
        const { actions, setShouldShowSidebar } = this.props;
        setShouldShowSidebar(false);
        actions.toggleVideoSelectionScreen(false);
    };

    clearLiveVideos = (e) => {
        if (e) { e.preventDefault(); }
        const { actions, setShouldShowSidebar } = this.props;
        setShouldShowSidebar(true);
        actions.getAssetsVideoListRequest();
        actions.updateVideoCameraSelection([]);
        actions.toggleVideoSelectionScreen(true);
    };

    clearAction = (e) => {
        const { params } = this.props;
        history.push(`/video/${params.selectedTab}`);
        this.clearLiveVideos(e);
    }

    render() {
        const { showSelectionScreen, selectedCameras, params } = this.props;

        return (
            <>
                <Row style={{ padding: '0px 0px' }}>
                    <Col xs={24}>
                        <span style={{
                            float: 'right',
                            fontSize: '12px',
                            fontFamily: 'Inter'
                        }}>
                            {`${selectedCameras.length} selected - `}
                            <a
                                href="#"
                                onClick={this.clearAction}>clear
                            </a>
                        </span>
                    </Col>
                </Row>
                {showSelectionScreen
                    ? <LiveVideosSelection params={params} toggleVideoScreen={this.toggleVideoScreen} clearLiveVideos={this.clearAction} />
                    : <LiveVideoScreen />}
            </>
        );
    }
}

LiveVideosTab.defaultProps = {
    showSelectionScreen: true,
    selectedCameras: [],
};

LiveVideosTab.propTypes = {
    actions: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    showSelectionScreen: PropTypes.bool,
    selectedCameras: PropTypes.array,
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        showSelectionScreen: state.video.showSelectionScreen,
        selectedCameras: state.video.selectedCameras,
        videoOnlineStatusChecking: state.video.videoOnlineStatusChecking,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...videoActions,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(LiveVideosTab);
